import React from 'react';
import AcademyLayout from './AcademyLayout';
import { csharpLessons } from '../../content/csharp/lessons';

export default function CsharpAcademy({ darkMode }) {
  return (
    <AcademyLayout
      darkMode={darkMode}
      lessons={csharpLessons}
      courseTitle="C# Design Patterns"
      courseIcon="⚙️"
      backPath="/academy"
    />
  );
}
